import React from "react";
import { useState } from "react";
import { Layout, Menu, Button, Dropdown, Drawer, Avatar } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined, DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ThemeToggle from '../components/ThemeToggle';
import styles from "./Navbar.module.css";

const { Header} = Layout;
const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const items = [
    {
      key: 'de',
      label: 'Deutsch',
      onClick: () => changeLanguage('de'),
    },
    {
      key: 'en',
      label: 'English',
      onClick: () => changeLanguage('en'),
    },
  ];

  return (
    <Dropdown menu={{ items }} className={styles.languageDropdown}>
      <Button className={styles.languageButton}>
        {i18n.language === "de" ? "Deutsch" : "English"} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

const Navbar = ({toggleSidebar, collapsed ,isToggleDisabled }) => {
  const { keycloak } = useKeycloak();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);

    const showDrawer = () => setIsDrawerVisible(true);
    const closeDrawer = () => setIsDrawerVisible(false);


    // ✅ Trigger Keycloak login when the button is clicked
    // ✅ Ensure login happens in the same tab
  const handleLogin = () => {
    keycloak.login({
      redirectUri: window.location.origin, // ✅ Ensures login stays in the same tab
    });
  };
  const handelRegister=()=>{
    navigate("/registration");


  }

  // ✅ Ensure logout also redirects properly
  const handleLogout = () => {
    keycloak.logout({
      redirectUri: window.location.origin, // ✅ Redirects user back to homepage after logout
    });
  };
   // Extract first name from token, or use preferred_username as fallback
   const firstName = keycloak.tokenParsed?.given_name || keycloak.tokenParsed?.preferred_username;

  return (
    <Header className={styles.navbar}>
        <div className={styles.navbarLeft}>
        <Button  type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={toggleSidebar} className={styles.toggleButton} />
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
  <div className={styles.appName}>MediSTime</div>
  <div className={styles.poweredText}>Powered by OptivaSoft</div>
</div>

      </div>
   
      <div className={styles.menu}>
    <LanguageSelector />
    <ThemeToggle size="middle" />
    <Button type="default" onClick={() => navigate('/prices')} className={styles.registerButton}>
    {t('prices')}
  </Button>
    
      {keycloak.authenticated ? (
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              { key: 'account', icon: <UserOutlined />, label: t('account'), onClick: () => navigate('/account') },
              { type: 'divider' },
              { key: 'logout', icon: <LogoutOutlined />, danger: true, label: t('logout'), onClick: handleLogout },
            ],
          }}
        >
          <Button type="text" className={styles.username}>
            <Avatar size="small" icon={<UserOutlined />} style={{ marginRight: 8 }} />
            {firstName} <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <>
        
        <Button type="primary" onClick={handleLogin} className={styles.loginButton}>
          {t('login')}
        </Button>
        <Button type="default" onClick={handelRegister} className={styles.registerButton}> {t('register.button')}</Button>
        </>
      )}
    </div>
    <Button
  className={styles.mobileMenuButton}
  type="text"
  icon={<MenuUnfoldOutlined />}
  onClick={showDrawer}
/>

{/* Drawer  */}
<Drawer
  title="MediSTime"
  placement="right"
  onClose={closeDrawer}
  open={isDrawerVisible}
  className={styles.drawer}
>
  <LanguageSelector />
  <div style={{ margin: '16px 0' }}>
    <ThemeToggle size="large" type="default" className={styles.drawerThemeToggle} />
  </div>
  <Button type="default" onClick={() => navigate('/prices')} className={styles.registerButton} block>
    {t('prices')}
  </Button>
  {keycloak.authenticated ? (
    <>
      <p className={styles.username}>{t('welcome')}, {firstName}</p>
      <Button type="default" icon={<UserOutlined />} onClick={() => { navigate('/account'); closeDrawer(); }} block style={{ marginBottom: 8 }}>
        {t('account')}
      </Button>
      <Button type="primary" danger onClick={handleLogout} className={styles.logoutButton} block>
        {t('logout')}
      </Button>
    </>
  ) : (
    <>
      <Button type="primary" onClick={handleLogin} className={styles.loginButton} block>
        {t('login')}
      </Button>
      <Button type="default" onClick={handelRegister} className={styles.registerButton} block>
        {t('register.button')}
      </Button>
    </>
  )}
</Drawer> 

  </Header>
  );
};

export default Navbar;